<!-- 关于羿畅 -->
<template>
	<div class='about'>
		<section>
			<article class='about-yc'>
				<div class='title'>羿畅介绍</div>
				<div class='line'></div>
				<div class='content'>
					<div class='description'>
						<div class='item' v-for='(item, index) in description' :key='index'>
							<div class='label'>{{ item.label }}</div>
							<div class='text'>{{ item.text }}</div>
						</div>
					</div>
					<img src='@/assets/image/aboutYC/ycjs.png' alt class='image' />
				</div>
			</article>
		</section>
		<section class='cloud-des-bg'>
			<article class='cloud-des'>
				<div class='text'>
					<p class='line_1'>智慧大交通(高速公路、普通公路、农村公路)建管养运智慧化建设、羿畅自建云和SaaS服务</p>
					<p class='line_2'>三大数亿级数据业务战略模块，以领先的技术和优质的服务助力行业发展与持续为客户创造价值</p>
				</div>
				<img src='@/assets/image/aboutYC/cloud_des.png' alt class='image' />
			</article>
		</section>
		<section>
			<article class='carousel'>
				<el-carousel :autoplay='false' height='600px' type='card' indicator-position='none' arrow='never'>
					<el-carousel-item v-for='(item, index) in imageList' :key='index'>
						<div style='display: flex;justify-content: center;'>
							<div class='card' :style='{ backgroundImage: `url(${item.bg})` }'>
								<div class='info'>
									<div class='label'>{{ item.label }}</div>
									<div class='tag'>{{ item.tag }}</div>
									<div class='line'></div>
									<div class='text'>{{ item.text }}</div>
								</div>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</article>
			<!--移动端适配-->
			<article class='carousel-mobile'>
				<div class='carousel-item' v-for='(item, index) in imageList' :key='index'
					:style='{ backgroundImage: `url(${item.bg})` }'>
					<div class='label'>{{ item.label }}</div>
					<div class='tag'>{{ item.tag }}</div>
					<div class='line'></div>
					<div class='text'>{{ item.text }}</div>
				</div>
			</article>
		</section>
		<section class='course-bg'>
			<article class='course'>
				<div class='title'>发展历程</div>
				<div class='content'>
					<div class='image'>
						<div class='text'>不忘初心</div>
					</div>
					<div class='history'>
						<div class='time'>
							<div class='prev' :class='{ active: activeYear === 2022 }' @click='handleYearChange(2022)'>
								2022
							</div>
							<div class='now' :class='{ active: activeYear === 2023 }' @click='handleYearChange(2023)'>
								2023
							</div>
							<div class='next' :class='{ active: activeYear === 2024 }' @click='handleYearChange(2024)'>
								2024
							</div>
							<div class='next' :class='{ active: activeYear === 2025 }' @click='handleYearChange(2025)'>
								2025
							</div>
						</div>
						<div class='line' :class='activeYear === 2022 ? "prev" : activeYear === 2023 ? "now" : "next"'>

						</div>
						<ul class='history-list'>
							<li class='list-item' v-for='(item, index) in historyList' :key='index'>
								<div class='time'>{{ item.time }}</div>
								<div class='text'>{{ item.text }}</div>
								<div class='img' v-if="item.img">
									<img :src='item.img' alt style="width: 100%;" />
								</div>
							</li>
						</ul>
					</div>
				</div>
			</article>
			<!--移动端适配-->
			<article class='course-mobile'>
				<div class='title'>发展历程</div>
				<div class='course-panel'>
					<div class='item' v-for='item in [2022, 2023, 2024, 2025]' :key='item' v-show='activeYear === item'>
						<div class='label'>
							<span class='start'>{{ (item + '').substring(0, 2) }}</span>
							<span class='end'>{{ (item + '').substring(2, 4) }}</span>
						</div>
						<ul class='history-list' ref='historyList'>
							<li class='list-item' v-for='(item, index) in historyList' :key='index'>
								<div class='time'>{{ item.time }}</div>
								<div class='text'>{{ item.text }}</div>
								<div class='img' v-if="item.img">
									<el-image class="img-info" :src="item.img" :preview-src-list="[item.img]">
									</el-image>
								</div>
							</li>
						</ul>
						<div class='image'>
							<div class='text'>不忘初心</div>
						</div>
					</div>
				</div>
				<div class='page-footer'>
					<div class='item' :class='{ active: item === activeYear }' v-for='item in [2022, 2023, 2024, 2025]'
						@click='activeYear = item' :key='item'></div>
				</div>
			</article>
		</section>
		<section>
			<article class='tags'>
				<div class='tag' v-for='(item, index) in tags' :key='index'>
					<img :src='item.img' alt class='image' />
					<p class='text'>{{ item.name }}</p>
				</div>
			</article>
		</section>
		<section class='footer_bg'>
			<article class='footer'>
				<div class='content'>
					<div class='logo_name'>
						<span class='cn'>羿畅科技</span>
						<br />
						<span class='en'>Yichang Technology</span>
					</div>
					<div class='item'>
						<div class='info' style='text-align: right;left:-130px;top:-70px'>
							<div class='label'>使命</div>
							<div class='text'>为国家数字交通建设作出贡献</div>
						</div>
						<img class='image' src='@/assets/image/aboutYC/icon_48.png' alt />
					</div>
					<div class='item' style='margin-left: auto'>
						<div class='info' style='right:-280px;bottom:-50px'>
							<div class='label'>价值观</div>
							<div class='text'>诚信经营，客户至上,质量为本，服务社会</div>
						</div>
						<img class='image' src='@/assets/image/aboutYC/icon_49.png' alt />
					</div>
					<div class='item'>
						<div class='info' style='text-align: right;left:-280px;bottom:-70px'>
							<div class='label'>愿景</div>
							<div class='text'>提供行业领先的数字交通解决方案，让交通更智能</div>
						</div>
						<img class='image' src='@/assets/image/aboutYC/icon_50.png' alt />
					</div>
				</div>
			</article>
			<!--移动端适配-->
			<article class='footer-mobile'>
				<div class='title'>企业文化</div>
				<div class='panel'>
					<div class='item' v-for='(item, index) in cultureList' :key='index'
						:style='{ backgroundImage: `url(${item.img})` }'>
						<div class='label'>{{ item.label }}</div>
						<p class='text'>{{ item.text }}</p>
					</div>
				</div>
			</article>
		</section>
	</div>
</template>

<script>
	export default {
		name: 'aboutYC',
		data() {
			return {
				activeYear: 2025,
				description: [{
						label: '业务遍布全国',
						text: `武汉羿畅科技有限公司（2019年成立）作为国家高新技术企业，以"技术创新赋能公路交通智能化 升级"为核心使命，专注智慧养护决策、农村公路信息化、智能巡查、基础设施数字化安全监测领域。凭 借22项专利技术，率先将物联网感知和大数据分析技术深度应用于公路管养全场景，为交通新基建提供 智能决策支持，驱动行业数字化转型进程。`
					},
					{
						label: '公路技术状况检测相关成果',
						text: `截止目前我司公路技术状况检测已服务全国多个省份，检测总里程达数十万公里，自主研发的“建管养运”大数据云平台，先后在数十个省、市、县得到广泛应用，
                    为数十家交通事业单位成功荣获国家级、省级四好农村公路示范县。`
					},
					{
						label: '重视技术原创性及持续创新发展的能力',
						text: `截止目前拥有36项软件著作权和18项产品发明专利证书，并获得了高新技术
                    企业证书、小巨人企业证书、ISO9001质量管理体系认证、ISO20000信息技术服务
                    管理体系认证、ISO27001信息安全管理体系认证、双软认证等资质证书。`
					},
				],
				imageList: [{
						label: '交通智脑',
						tag: '智慧大交通感知、协同超级智脑',
						text: '信息全感知、事件全预警、业务全管理，服务全方位的安全、便捷、高效的体验',
						bg: require('@/assets/image/aboutYC/about_bg1.png')
					},
					{
						label: '羿畅云',
						tag: '千万条日活数据在线数据分析专用云',
						text: '智慧大交通领域专业的数据处理，精准分析服务',
						bg: require('@/assets/image/aboutYC/about_bg2.png')
					},
					{
						label: 'SaaS服务',
						tag: '为交管客户提供智能化、专业化共享软件方案',
						text: '智能化、专业化共享软件方案，帮助用户实现全链信息化',
						bg: require('@/assets/image/aboutYC/about_bg3.png')
					},
				],
				year_2022: [{
						time: '2022.01',
						text: '羿畅科技与山东高速工程检测有限公司展开深度合作'
					},
					{
						time: '2022.06',
						text: '羿畅科技为甘肃省公路事业发展中心提供全方位技术咨询服务'
					},
					{
						time: '2022.09',
						text: '羿畅科技与天津交通科学研究院建立战略合作伙伴关系'
					},
					{
						time: '2022.11',
						text: '智慧交通综合管理平台通过三级等保'
					}
				],
				year_2023: [{
						time: '2023.03',
						text: '羿畅农村公路养护管理平台入选交通部第十三届干部学院培训典型案例'
					},
					{
						time: '2023.06',
						text: '2017年交付潜江农村公路养护综合管理平台入选湖北省“一路一档”典型案例并由湖北省交通运输厅推荐至交通运输部列为典型案例'
					},
					{
						time: '2023.06',
						text: '2019年交付远安县农村公路养护综合管理平台入选湖北省“一路一档”典型案例并由湖北省交通运输厅推荐至交通运输部列为典型案例'
					},
				],
				year_2024: [{
					time: '2024.01',
					text: '1月5日，羿畅科技匠心打造AI道路病害巡查系统，在这具有里程碑意义的一天正式上线！本产品以“智驱未来，护航坦途”这一富含深意的主题，赋能道路养护行业的变革升级。'
				}],
				year_2025: [{
					time: '2025.06',
					text: '“羿路巡” 第二代全新发布---集成北斗厘米级定位、工业相机及超算终端，搭载深度学习算法，实现病害实时识别与毫米级定位。设备可在80-120km/h作业时速下，精准捕捉裂缝、坑槽等15+类道路异常事件，通过 5G 网络毫秒级回传至养护决策平台，自动生成含坐标的养护工单。其轻量化、低成本、高精准、快部署、易维护等特性，全面赋能道路管养数字化转型 —— 助力管养单位巡查效率提升80%、养护成本降低42%，以科技力量全程守护道路全生命周期安全畅通。',
					img: require('@/assets/image/aboutYC/about_2025.png')
				}],
				tags: [{
						name: '高新技术企业证书',
						img: require('@/assets/image/aboutYC/icon_41.png')
					},
					{
						name: '发明专利证书',
						img: require('@/assets/image/aboutYC/icon_42.png')
					},
					{
						name: '知识产权管理体系认证证书',
						img: require('@/assets/image/aboutYC/icon_43.png')
					},
					{
						name: '企业信用等级AAA级证书',
						img: require('@/assets/image/aboutYC/icon_44.png')
					},
					{
						name: 'CMMI五级证书',
						img: require('@/assets/image/aboutYC/icon_45.png')
					},
					{
						name: 'ITSS三级证书',
						img: require('@/assets/image/aboutYC/icon_46.png')
					},
					{
						name: '软件企业证书',
						img: require('@/assets/image/aboutYC/icon_51.png')
					},
					{
						name: '软件产品证书',
						img: require('@/assets/image/aboutYC/icon_52.png')
					},
				],
				cultureList: [{
						label: '价值观',
						text: '诚信经营，客户至上,质量为本，服务社会；',
						img: require('@/assets/image/aboutYC/icon_61.png')
					},
					{
						label: '使命',
						text: '为国家数字交通建设作出贡献',
						img: require('@/assets/image/aboutYC/icon_61.png')
					},
					{
						label: '愿景',
						text: '提供行业领先的数字交通解决方案，让交通更智能',
						img: require('@/assets/image/aboutYC/icon_61.png')
					},
				]

			};
		},
		computed: {
			historyList() {
				return this.activeYear === 2022 ? this.year_2022 : this.activeYear === 2023 ? this.year_2023 : this
					.activeYear === 2024 ? this.year_2024 : this.year_2025;
			},
		},
		//刷新或通过URL地址进入页面时，同步背景图和标题
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.$nextTick(() => {
					vm.$bus.$emit('changePageTitleAndBackground', {
						page: 'aboutYC'
					});
				});
			});
		},
		methods: {
			handleYearChange(type) {
				this.activeYear = type;
			}
		},
	};
</script>

<style lang='scss' scoped>
	.about {
		height: 100%;
		width: 100%;

		section {
			margin-top: 100px;

			article {
				margin: 0 auto;
				width: 1200px;
			}
		}

		.about-yc {
			.title {
				font-size: 36px;
				font-weight: bold;
			}

			.line {
				margin-top: 30px;
				border-bottom: 2px solid #0079fe;
				width: 70px;
			}

			.content {
				display: flex;
				justify-content: space-between;

				.description {
					width: calc(100% - 550px);

					.item {
						margin-top: 50px;

						.label {
							font-size: 20px;
							font-weight: bold;
						}

						.text {
							margin-top: 30px;
							font-size: 16px;
							line-height: 32px;
							text-align: justify;
						}
					}
				}

				.image {
					height: 440px;
					width: 440px;
					object-fit: fill;
					margin-top: auto;
				}
			}
		}

		.cloud-des-bg {
			background-image: url("~@/assets/image/aboutYC/ycjs_bg.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}

		.cloud-des {
			height: 200px;
			display: flex;
			align-items: center;

			.text {
				color: #ffffff;
				margin-right: 64px;
				display: flex;
				flex-direction: column;

				.line_1 {
					font-size: 18px;
					font-weight: bold;
					margin-bottom: 24px;
				}

				.line_2 {
					font-size: 16px;
				}
			}

			.image {
				height: 178px;
				width: 178px;
				object-fit: fill;
			}
		}

		.carousel-mobile {
			display: none;
		}

		.carousel {
			width: 1200px;
			text-align: center;

			.card {
				width: 470px;
				height: 600px;
				background-size: 100% 100%;
				background-repeat: no-repeat;

				.info {
					box-sizing: border-box;
					padding: 0 70px;
					height: 100%;
					width: 100%;
					background-color: rgba(0, 0, 0, 0.2);
					display: flex;
					flex-direction: column;
					justify-content: center;
					color: #ffffff;

					.label {
						font-size: 30px;
					}

					.tag {
						margin-top: 30px;
						font-size: 14px;
					}

					.line {
						border-bottom: 2px solid #ffffff;
						width: 40px;
						margin: 50px auto;
					}

					.text {
						font-size: 20px;
						line-height: 30px;
						text-align: justify;
						text-align-last: center;
					}
				}
			}
		}

		.course-bg {
			background-image: url("~@/assets/image/aboutYC/fzlc_bg.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}

		.course-mobile {
			display: none;
		}

		.course {
			padding: 100px 0;

			.title {
				font-size: 36px;
				text-align: center;
			}

			.content {
				margin-top: 80px;
				display: flex;
				justify-content: space-between;

				.image {
					width: 386px;
					height: 516px;
					background-image: url("~@/assets/image/aboutYC/fzlc_bg1.png");
					background-size: 100% 100%;
					display: flex;

					.text {
						width: 100%;
						margin-top: auto;
						font-size: 82px;
						text-align: center;
						color: #ffffff;
						padding: 110px 0 8px 0;
						letter-spacing: 0.1em;
						background: linear-gradient(180deg,
								rgba(0, 121, 254, 0) 0%,
								#0079fe 100%);
					}
				}

				.history {
					width: 700px;
					height: 516px;

					.time {
						display: flex;

						.prev,
						.next,
						.now {
							cursor: pointer;
							padding: 16px 0;
							width: calc(100% / 3);
							font-size: 52px;
							font-weight: bold;
							color: #999999;
							display: flex;
							align-items: center;
							justify-content: center;
							transition: color 0.2s ease-in-out;
						}

						.active {
							color: #0079fe;
							font-size: 72px;
						}
					}

					.line {
						width: 100%;
						height: 2px;
						background: linear-gradient(270deg,
								rgba(0, 121, 254, 0) 0%,
								#7dbbfe 51%,
								rgba(0, 121, 254, 0) 100%);

						&::before {
							content: "";
							display: inline-block;
							height: 15px;
							width: 15px;
							border: 5px solid #b9dbff;
							background: #0079fe;
							border-radius: 50%;
							transition: all 0.2s ease-in-out;
						}
					}

					.now::before {
						transform: translateY(-33%) translateX(330px);
					}

					.prev::before {
						transform: translateY(-33%) translateX(105px);
					}

					.next::before {
						transform: translateY(-33%) translateX(575px);
					}

					.history-list {
						height: 350px;
						overflow-y: scroll;
						margin-top: 64px;

						&::-webkit-scrollbar {
							width: 5px;
							height: 10px;
						}

						&::-webkit-scrollbar-track {
							background: rgb(239, 239, 239);
							border-radius: 2px;
						}

						&::-webkit-scrollbar-thumb {
							background: #1890ff;
							border-radius: 10px;
						}

						&::-webkit-scrollbar-thumb:hover {
							background: #66b1ff;
						}

						.list-item {
							margin-bottom: 24px;

							.time {
								font-size: 24px;

								&::before {
									content: "";
									display: inline-block;
									height: 12px;
									width: 12px;
									background: #0079fe;
									border-radius: 50%;
									margin-right: 20px;
									transform: translateY(6px);
								}
							}

							.text {
								margin-top: 30px;
								font-size: 16px;
								padding-left: 32px;
								line-height: 20px;
							}

							.img {
								margin-top: 30px;
								padding-left: 32px;

								.img-info {
									width: 100%;
								}
							}
						}
					}
				}
			}
		}

		.tags {
			display: flex;
			justify-content: space-between;

			.tag {
				width: 120px;
				text-align: center;

				.image {
					height: 80px;
					width: 80px;
					object-fit: fill;
				}

				.text {
					margin-top: 20px;
					text-align-last: center;
					font-size: 16px;
					line-height: 20px;
				}
			}
		}

		.footer_bg {
			background-image: url("~@/assets/image/aboutYC/aboutYC_bg2.png");
			background-size: 100% 100%;
		}

		.footer-mobile {
			display: none;
		}

		.footer {
			box-sizing: border-box;
			height: 822px;
			padding: 140px 200px;

			.content {
				box-sizing: border-box;
				height: 100%;
				width: 100%;
				background-image: url("~@/assets/image/aboutYC/footer_img.png");
				background-size: 100% 100%;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				padding: 0 110px 40px 200px;
				position: relative;

				.logo_name {
					color: #ffffff;
					position: absolute;
					top: 45%;
					left: 40%;

					.cn {
						font-size: 34px;
					}

					.en {
						font-size: 14px;
					}
				}

				.item {
					position: relative;

					.info {
						width: fit-content;
						position: absolute;

						.label {
							font-size: 24px;
							font-weight: bold;
							color: #ffffff;
						}

						.text {
							color: #ffffff;
							margin-top: 10px;
							font-size: 16px;
						}
					}

					.image {
						height: 95px;
						width: 95px;
						object-fit: fill;
					}
				}
			}
		}
	}

	@import "./style.scss";
</style>